var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Getter, Inject, Mutation, State } from 'vue-class-state';
import { checkLogin } from '../../common/decorators';
import { jsonp, post } from '../../common/http';
/**
 * 收藏数据管理
 */
export class CollectState {
    constructor() {
        this.tabs = [
            {
                name: '全部',
                followList: [],
                pidx: 0,
            },
            {
                name: '电视剧',
                type: 2,
                followList: [],
                pidx: 0,
            },
            {
                name: '电影',
                type: 1,
                followList: [],
                pidx: 0,
            },
            {
                name: '综艺',
                type: 10,
                followList: [],
                pidx: 0,
            },
            {
                name: '动漫',
                type: 3,
                followList: [],
                pidx: 0,
            },
            {
                name: '记录片',
                type: 9,
                followList: [],
                pidx: 0,
            },
            {
                name: '直播',
                type: 0,
                followList: [],
                pidx: 0,
            },
            {
                name: '其他',
                followList: [],
                pidx: 0,
            },
        ];
        this.hasInit = false;
        this.activeIndex = 0;
    }
    get activeTab() {
        return this.tabs[this.activeIndex];
    }
    get dataLength() {
        return this.tabs.reduce((num, item) => {
            num += item.followList.length;
            return num;
        }, 0);
    }
    initData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.tabs.some(item => item === this.activeTab)) {
                this.tabs.unshift(this.activeTab);
            }
            try {
                const subTotalData = yield jsonp('//access.video.qq.com/fcgi/attent_list', {
                    vappid: '29737725',
                    vsecret: '0ad3fe84a16e82739bea284c5c75ced12b0799fe30d300a5',
                    vplatform: '2',
                    dataVersion: '0',
                });
                const subList = subTotalData.data.VideoAttentInfoList;
                this.arrangeSubData(subList);
            }
            catch (error) {
                this.hasInit = true;
            }
        });
    }
    arrangeSubData(data) {
        data.forEach((item) => {
            this.tabs[0].followList.push(item);
            // 除了全部tab以外，关注项的归属tab
            let ownerTabIndex = 7;
            if (item.cid || item.lid) {
                try {
                    const type = item.vecUnionData[0].vecFieldValue.find(item => item.strKey === 'type').strValue;
                    switch (type) {
                        case '2':
                            ownerTabIndex = 1;
                            break;
                        case '1':
                            ownerTabIndex = 2;
                            break;
                        case '10':
                            ownerTabIndex = 3;
                            break;
                        case '3':
                            ownerTabIndex = 4;
                            break;
                        case '9':
                            ownerTabIndex = 5;
                            break;
                        default:
                            ownerTabIndex = 7;
                            break;
                    }
                    // TODO workaround，待后台修复
                }
                catch (err) {
                    ownerTabIndex = 6;
                }
            }
            else if (item.pid) {
                ownerTabIndex = 6;
            }
            this.tabs[ownerTabIndex].followList.push(item);
        });
        this.followKeys = data.map(item => ({ attentKey: item.attentKey }));
    }
    setActiveIndex(type) {
        this.activeIndex = type;
    }
    /**
       * 删除收藏
       * @param followId
       */
    delFollow(attentKey) {
        return __awaiter(this, void 0, void 0, function* () {
            // tslint:disable-next-line:max-line-length
            const res = yield post('//access.video.qq.com/fcgi/attent_modify?vappid=29737725&vsecret=0ad3fe84a16e82739bea284c5c75ced12b0799fe30d300a5&vplatform=2&raw=1', {
                attentKeyList: [{ attentKey }],
                option: 2,
            }, false, true);
            console.log(res);
            if (res.ret === 0) {
                if (res.data && res.data.errCode === 0) {
                    this.setDelFollow(attentKey);
                }
            }
        });
    }
    delAllFollow() {
        return __awaiter(this, void 0, void 0, function* () {
            // ret==-11 no login
            // tslint:disable-next-line:max-line-length
            const res = yield post('//access.video.qq.com/fcgi/attent_modify?vappid=29737725&vsecret=0ad3fe84a16e82739bea284c5c75ced12b0799fe30d300a5&vplatform=2&raw=1', {
                attentKeyList: this.followKeys,
                option: 2,
            }, false, true);
            console.log(res);
            if (res.ret === 0) {
                if (res.data && res.data.errCode === 0) {
                    this.clearLocalState();
                }
            }
        });
    }
    clearLocalState() {
        this.tabs.forEach((tabs) => {
            tabs.followList = [];
            tabs.pidx = 0;
        });
    }
    setDelFollow(attentKey) {
        this.tabs.forEach((item) => {
            const deletedIndex = item.followList.findIndex(item => item.attentKey === attentKey);
            if (deletedIndex !== -1) {
                item.followList.splice(deletedIndex, 1);
            }
        });
    }
}
__decorate([
    State
], CollectState.prototype, "tabs", void 0);
__decorate([
    State
], CollectState.prototype, "activeIndex", void 0);
__decorate([
    Getter
], CollectState.prototype, "activeTab", null);
__decorate([
    Getter
], CollectState.prototype, "dataLength", null);
__decorate([
    checkLogin
], CollectState.prototype, "initData", null);
__decorate([
    Mutation
], CollectState.prototype, "arrangeSubData", null);
__decorate([
    Mutation
], CollectState.prototype, "setActiveIndex", null);
__decorate([
    checkLogin
], CollectState.prototype, "delFollow", null);
__decorate([
    checkLogin
], CollectState.prototype, "delAllFollow", null);
__decorate([
    Mutation
], CollectState.prototype, "clearLocalState", null);
__decorate([
    Mutation
], CollectState.prototype, "setDelFollow", null);
export const ICollectState = Inject('collect');
